module.exports = __webpack_public_path__ + "static/media/star_white.28da1538.svg";